<template>
  <b-card title="GPS" body-class="gps-card">
    <table class="table">
      <tr>
        <td>
          <strong>Longitude</strong>
        </td>
        <td class="text-right" >
          {{gps_location_longitude ? gps_location_longitude  + '°' : ''}}
        </td>
      </tr>
      <tr>
        <td>
          <strong>Longitude error</strong>
        </td>
        <td class="text-right" >
          {{gps_location_longitude_error ? gps_location_longitude_error + 'm' : ''}}
        </td>
      </tr>
      <tr>
        <td>
          <strong>Latitude</strong>
        </td>
        <td class=" text-right" >
          {{gps_location_latitude ? gps_location_latitude + '°' : ''}}
        </td>
      </tr>
      <tr>
        <td>
          <strong>Latitude error</strong>
        </td>
        <td class=" text-right" >
          {{gps_location_latitude_error ? gps_location_latitude_error + 'm' : ''}}
        </td>
      </tr>
      <tr>
        <td>
          <strong>Altitude</strong>
        </td>
        <td class=" text-right" >
          {{gps_location_altitude ? gps_location_altitude + 'm' : ''}}
        </td>
      </tr>
      <tr>
        <td>
          <strong>Altitude error</strong>
        </td>
        <td class=" text-right" >
          {{gps_location_altitude_error ? gps_location_altitude_error + 'm' : ''}}
        </td>
      </tr>
      <tr>
        <td>
          <strong>Fix type</strong>
        </td>
        <td class=" text-right" >
          {{gps_location_fix_type}}
        </td>
      </tr>
      <tr>
        <td>
          <strong>Satellites number</strong>
        </td>
        <td class=" text-right" >
          {{gps_location_num_satellites}}
        </td>
      </tr>
    </table>
    <CardTimestampFooter v-bind:timestamp="timestamp"/>
  </b-card>
</template>
<script>
import CardTimestampFooter from '@/components/Device/CardTimestampFooter/CardTimestampFooter';

export default {
  name: 'GPSLocationCard',
  components: {CardTimestampFooter},
  props: ['gps_location'],
  computed: {
   gps_location_longitude(){
     return this._props.gps_location ? this._props.gps_location.longitude: '';
   },
   gps_location_longitude_error(){
     return this._props.gps_location ? this._props.gps_location.longitude_error: '';
   },
   gps_location_latitude(){
     return this._props.gps_location ? this._props.gps_location.latitude: '';
   },
   gps_location_latitude_error(){
     return this._props.gps_location ? this._props.gps_location.latitude_error: '';
   },
   gps_location_altitude(){
     return this._props.gps_location ? this._props.gps_location.altitude: '';
   },
   gps_location_altitude_error(){
     return this._props.gps_location ? this._props.gps_location.altitude_error: '';
   },
   gps_location_fix_type(){
     return this._props.gps_location ? this._props.gps_location.fix_type : '';
   },
   gps_location_num_satellites(){
     return this._props.gps_location ? this._props.gps_location.num_satellites : '';
   },
   timestamp(){
     return this._props.gps_location && this._props.gps_location.timestamp ? this._props.gps_location.timestamp : null;
   }
  }
}
</script>
<style src="./GPSLocationCard.scss" lang="scss" scoped/>
